import { useCallback } from 'react';
import ShiftDigitalEventName from '~/constants/dealership/ShiftDigitalEventName';
import { isNonProd } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useDealershipId } from '~/context/dealership/StaticContext';
import type { EventPayloads } from '~/contracts/dealership/ShiftDigital';

export default function useSendToShiftDigital() {
  const dealershipId = useDealershipId();
  const trackEvent = useTrackEvent();

  return useCallback(
    <Key extends ShiftDigitalEventName>(
      event: Key,
      payload: EventPayloads[Key]
    ) => {
      window.sd?.('dataLayer', { events: event, ...payload });
      window.sd?.('send');

      trackEvent('ShiftDigital', { dealershipId, event, payload });

      if (isNonProd) {
        console.debug('Send to shift digital', event, payload);
      }
    },
    [dealershipId, trackEvent]
  );
}
